import React, { useState, useEffect, useRef } from "react";
import { FormattedMessage } from "react-intl";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import classNames from "classnames/bind";
import { Space, Card, Button } from "@masterteam/mt-design-react";

import { ReactComponent as LogoutIcon } from "../../../assets/images/logout.svg";
import { ReactComponent as DelegateIcon } from "../../../assets/images/delegate.svg";
import { ReactComponent as DownArrow } from "../../../assets/images/down-arrow.svg";
import {
  activateDelegation,
  deactivateDelegation,
  logout
} from "../../../reducers/user";
import UserInfo from "../../UserInfo";

import styles from "./UserDropdown.module.scss";

const cx = classNames.bind(styles);

function UserDropdown() {
  const dispatch = useDispatch();
  const history = useHistory();
  const [userData, currentUser, delegations] = useSelector(({ user }) => [
    user.mainUser,
    user.user,
    user.delegations
  ]);
  const [isOpen, setIsOpen] = useState(false);
  const wrapperRef = useRef();

  const handleClickOutside = event => {
    if (wrapperRef?.current && !wrapperRef?.current?.contains(event.target)) {
      setIsOpen(false);
    }
  };

  const toggleDelegation = (id, isCurrentUser) => {
    dispatch(isCurrentUser ? deactivateDelegation() : activateDelegation(id));
  };

  const handleLogout = () => {
    setIsOpen(false);
    dispatch(logout());
  };

  const handleDelegate = () => {
    setIsOpen(false);
    history.push("/splus/delegations");
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const showDelegations = currentUser?.screens?.includes("DE");

  return (
    <Space className={styles.userDropdown} direction="vertical">
      <Button
        fill="none"
        variant="dark"
        size="medium"
        onClick={() => setIsOpen(!isOpen)}
        TailIcon={DownArrow}
      >
        <UserInfo
          item={userData}
          style={{
            height: 25,
            width: 25
          }}
        />
      </Button>

      <Card
        className={cx({
          dropdownList: true,
          displayBlock: isOpen
        })}
      >
        <div ref={wrapperRef}>
          {showDelegations && (
            <Button
              size="large"
              fill="none"
              variant="dark"
              Icon={DelegateIcon}
              onClick={() => handleDelegate()}
              block
            >
              <FormattedMessage id="header-delegation" />
            </Button>
          )}
          {delegations?.map(item => {
            const isCurrentUser =
              item.FromUser?.UserName === currentUser.UserName;
            return (
              <Button
                key={item.ID}
                size="large"
                fill={isCurrentUser ? "full" : "none"}
                variant={isCurrentUser ? "primary" : "dark"}
                className={cx({
                  selected: item.FromUser?.UserName === currentUser.UserName
                })}
                onClick={() => toggleDelegation(item.ID, isCurrentUser)}
                block
              >
                <UserInfo
                  item={item.FromUser}
                  style={{
                    height: 25,
                    width: 25
                  }}
                />
              </Button>
            );
          })}
          <Button
            size="large"
            fill="none"
            variant="dark"
            Icon={LogoutIcon}
            onClick={() => handleLogout()}
            block
          >
            <FormattedMessage id="logout" />
          </Button>
        </div>
      </Card>
    </Space>
  );
}

export default UserDropdown;
